/**
 * Facets enhancements (non-invasive)
 *
 * Purpose:
 * - Keep native theme/Shopify facets behavior untouched
 * - Add lightweight accessibility + state classes only
 * - Avoid inline width/transform overrides that can break desktop/mobile drawers
 */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '.t4s-filter-hidden.t4s-drawer';
  var FACET_WRAPPER_SELECTOR = '.t4s-facets, .t4s-facet, [data-filter-links]';

  function setDrawerStateClass(drawer) {
    if (!drawer) return;
    var isOpen = drawer.getAttribute('aria-hidden') === 'false';
    drawer.classList.toggle('is-filter-open', isOpen);
    drawer.classList.toggle('is-filter-closed', !isOpen);
  }

  function enhanceDrawer(drawer) {
    if (!drawer || drawer.dataset.ktFacetsEnhanced === 'true') return;
    drawer.dataset.ktFacetsEnhanced = 'true';

    // Some templates render the drawer without aria-hidden; default to closed.
    if (!drawer.hasAttribute('aria-hidden')) {
      drawer.setAttribute('aria-hidden', 'true');
    }

    setDrawerStateClass(drawer);

    // Keep ARIA control relationship clear for assistive tech.
    if (!drawer.hasAttribute('role')) {
      drawer.setAttribute('role', 'dialog');
    }
    if (!drawer.hasAttribute('aria-modal')) {
      drawer.setAttribute('aria-modal', 'true');
    }

    // Watch native open/close changes without forcing layout.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'aria-hidden') {
          setDrawerStateClass(drawer);
        }
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function markFacetWrappers() {
    var wrappers = document.querySelectorAll(FACET_WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i += 1) {
      wrappers[i].classList.add('kt-facets-ready');
    }
  }

  function initFacetsEnhancements() {
    var drawers = document.querySelectorAll(DRAWER_SELECTOR);
    for (var i = 0; i < drawers.length; i += 1) {
      enhanceDrawer(drawers[i]);
    }
    markFacetWrappers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetsEnhancements);
  } else {
    initFacetsEnhancements();
  }

  // Re-run after dynamic section renders.
  document.addEventListener('shopify:section:load', initFacetsEnhancements);
})();
